import React from 'react'

import clsx from 'clsx'

import arrowsBgSVG from 'assets/resources-bg.svg'

import classes from './ContainerWithArrowsBg.module.scss'

/** @type {import('./types').default} */
const ContainerWithArrowsBg = ({ className, children, ...props }) => (
  <div className={clsx('ContainerWithArrowsBg', classes.root, className)} {...props}>
    <div className={classes.backgroundImageContainer}>
      <img src={arrowsBgSVG.src} alt="" className={classes.backgroundSvg} width="645" height="1440" />
    </div>
    <div className={classes.content}>{children}</div>
  </div>
)

export default ContainerWithArrowsBg
